import React from 'react'
import { CloseIcon, CheckIcon } from '../../../_components'
import { userStatus, SimpleFetch, history } from '../../../_helpers'
import { toast } from 'react-toastify'

export const saveMomentum = async (data, domain, status, scheduled, queryType) => {
  let cachedData = data

  const momentum_title = cachedData.momentum_title
  delete cachedData.momentum_title

  if ( !cachedData.dispatcher ) cachedData.dispatcher = {}

  const channel_uuid = cachedData.channel_uuid ?? cachedData.dispatcher.dispatcher_type
  delete cachedData.dispatcher.dispatcher_type

  cachedData.dispatcher.name = `${new Date().getTime()}_${momentum_title.toLowerCase().replace(/ /g, '_')}`

  const removedRawObjects = Object.keys(cachedData).map( key => {
    if ( key.includes( 'raw' ) ) return undefined

    if ( typeof cachedData[key] !== 'object' || cachedData[key] === null ) return undefined

    if ( Array.isArray( cachedData[key] ) ) return undefined

    if ( !( 'filter' in cachedData[key] ) ) return undefined

    return { [key]: cachedData[key] }
  })
  const filters = removedRawObjects.filter(t => t !== undefined)

  const momentumFilters = filters.map(filter => {
    try {
      const obj = {
        type: Object.keys(filter)[0],
        values: [filter[Object.keys(filter)]]
      }
  
      return obj
    } catch ( err ) {
      return filters
    }
  })

  const userInfo = userStatus()
  const worktime = ( () => {
    if ( !data.worktime ) return undefined
    const areWeekDays = !!data.worktime.weekdays?.length
    const areStartAt = !!data.worktime.start_at
    const areStopAt = !!data.worktime.stop_at
    const areEvery = areWeekDays && areStartAt && areStopAt

    if ( areEvery ) return data.worktime

    return undefined
  } )()
  const obj = {
    channel_uuid,
    momentum_title,
    domain_uuid: domain,
    user_uuid: userInfo.user_uuid,
    company_uuid: userInfo.company_uuid,
    momentum_description: "",
    type: queryType ?? "momentum",
    active: 1,
    status,
    scheduled_at: scheduled || null,
    momentums: momentumFilters,
    worktime
  }
  console.log( { obj } )

  if ( data.uuid ) obj.uuid = data.uuid

  const req = obj.uuid
    ? await SimpleFetch('PUT', {}, obj, 'momentum', `momentum/update`)
    : await SimpleFetch('POST', {}, obj, 'momentum', `momentum/create`)

  if ( req.status !== 200 ) return toast.warn(<><CloseIcon /> Não foi possível cadastrar seu <strong>Momentum</strong>. Tente novamente mais tarde.</>, {
    position: toast.POSITION.TOP_RIGHT,
    className: 'toast--white toast--error'
  });

  let redirect = "/v2/momentums"
  if ( queryType === "campaign" ) redirect = "/v2/campaigns"

  if ( obj.uuid )
    if ( status === 'Draft' )
      toast.warn( <><CheckIcon /> Rascunho atualizado com <strong>sucesso</strong>!.</>, {
        position: toast.POSITION.TOP_RIGHT,
        className: 'toast--white toast--success'
      } )

    else toast.warn((
      <>
        <CheckIcon /> Momentum Atualizado com <strong>sucesso</strong>! Você será redirecionado em breve.
      </>
    ), {
        position: toast.POSITION.TOP_RIGHT,
        className: 'toast--white toast--success',
        onClose: () => history.push(redirect)
      })

  else if ( status === 'Draft' ) {
    toast.warn(<><CheckIcon /> Momentum cadastrado como rascunho com <strong>sucesso</strong>!</>, {
      position: toast.POSITION.TOP_RIGHT,
      className: 'toast--white toast--success'
    } )
  }

  else toast.warn(<><CheckIcon /> Momentum cadastrado com <strong>sucesso</strong>! Você será redirecionado em breve.</>, {
    position: toast.POSITION.TOP_RIGHT,
    className: 'toast--white toast--success',
    onClose: () => history.push(redirect)
  });
}